import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { API_PATHS } from '../config/api-paths';
import { DataImportLog, DataImportResult, EdDataImportApi } from '../tokens/ed-data-import.token';

/**
 * REST implementation of the E-D Data Import API (PRD §3.11, EM-838).
 *
 *   POST /services/embedded/api/v1/ed/data-imports (multipart)
 *   GET  /services/embedded/api/v1/ed/data-imports
 *
 * E-D-scoped server-side (Rule 22). REST-only (Rules 07/10). Bound to ED_DATA_IMPORT.
 */
@Injectable({ providedIn: 'root' })
export class EdDataImportRestService implements EdDataImportApi {
  private readonly http = inject(HttpClient);
  private readonly base = `${API_PATHS.EMBEDDED_API_BASE}/v1/ed/data-imports`;

  importFile(file: File): Observable<DataImportResult> {
    const form = new FormData();
    form.append('file', file, file.name);
    return this.http.post<DataImportResult>(this.base, form);
  }

  getImportLog(): Observable<DataImportLog[]> {
    return this.http.get<DataImportLog[]>(this.base);
  }
}
